<template>
  <b-modal
    id="transaction-modal"
    v-model="isTransactionPending"
    title="Confirm Transaction"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
  >
    <span id="spinner-container">
    <img v-if="isSacrificeEvent" src="./assets/timesup.png"/>
    <img v-else src="./assets/zoombies_head.svg"/>
    <b-spinner id="spinnyboi" variant="light"/>
    </span>
    <span v-if="isTransactionConfirmed" class="transaction-confirm-text">Pending...</span>
    <span v-else class="transaction-confirm-text">Please confirm the transaction.</span>
    <button class="close-button" @click="$bvModal.hide('transaction-modal')">
      Close
    </button>
  </b-modal>
</template>

<script>
export default {
  name: "TransactionModal",
  computed: {
    isTransactionPending: {
      get: function () {
        return this.$store.state.isTransactionPending;
      },
      set: function (value) {
        this.$store.dispatch("setIsTransactionPending", value);
      },
    },
    isSacrificeEvent: {
      get: function () {
        return this.$store.state.isSacrificeEvent;
      },
      set: function (value) {
        this.$store.dispatch("setIsSacrificeEvent", value);
      },
    },
    isTransactionConfirmed: {
      get: function () {
        return this.$store.state.isTransactionConfirmed;
      },
      set: function (value) {
        this.$store.dispatch("setIsTransactionConfirmed", value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-content {
  background-color: #1E162F;
  border: 3px solid;
  border-color: #00D1FF;
  border-radius: 15px;
  width: 100%;
  height: 280px;
}

.modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 50px 0;
}

.transaction-confirm-text {
  font-family: "Truculenta", sans-serif;
  font-size: 25px;
  font-weight: 700;
  color: #00D1FF;
  display: table;
  margin: 0 auto;
}

.close-button {
  display: block;
  margin: 0 auto;
  margin-top: 10px;
  width: 100px;
  height: 40px;
  color: #ffffff;
  background-color: #dc3545;
  border: 3px solid;
  border-color: #dc3545;
  border-radius: 15px;
}

#spinner-container {
  padding-top: 20px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;

  img {
    position: absolute;
    width: 85px;
    height: 85px;
  }
  #spinnyboi {
    width: 100px;
    height: 100px;
    background: transparent;
  }
}
</style>
